
import { tryFind, ofList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { empty, reverse, tail, cons, head, isEmpty, tryFind as tryFind_1, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { equals, comparePrimitives } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { WaveIndexT, WavePath } from "./CommonTypes.js";

function componentsBySheet(ldcs) {
    return ofList(map((ldc) => [ldc.Name, ldc.CanvasState[0]], ldcs), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
}

function sheetInstantiatedBy(comp) {
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        return matchValue.fields[0].Name;
    }
    else {
        return undefined;
    }
}

/**
 * The label path of a component named by id and access path, or None where the design does not
 * hold it - a selection made against a design that has since changed.
 */
export function pathOfComponent(ldcs, topSheet, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const sheets = componentsBySheet(ldcs);
    const componentOn = (sheet, id) => {
        const option_1 = tryFind(sheet, sheets);
        if (option_1 != null) {
            return tryFind_1((comp) => equals(comp.Id, id), option_1);
        }
        else {
            return undefined;
        }
    };
    const walk = (sheet_1_mut, labels_mut, remaining_mut) => {
        walk:
        while (true) {
            const sheet_1 = sheet_1_mut, labels = labels_mut, remaining = remaining_mut;
            if (!isEmpty(remaining)) {
                const option_7 = componentOn(sheet_1, head(remaining));
                if (option_7 != null) {
                    const comp_2 = option_7;
                    const option_5 = sheetInstantiatedBy(comp_2);
                    if (option_5 != null) {
                        sheet_1_mut = option_5;
                        labels_mut = cons(comp_2.Label, labels);
                        remaining_mut = tail(remaining);
                        continue walk;
                    }
                    else {
                        return undefined;
                    }
                }
                else {
                    return undefined;
                }
            }
            else {
                const option_3 = componentOn(sheet_1, _arg[0]);
                if (option_3 != null) {
                    return reverse(cons(option_3.Label, labels));
                }
                else {
                    return undefined;
                }
            }
            break;
        }
    };
    return walk(topSheet, empty(), reverse(_arg[1]));
}

/**
 * The component a label path names, or None where the design does not hold it - renamed or
 * deleted since the selection was saved, which is a wave that is simply no longer offered.
 */
export function componentOfPath(ldcs, topSheet, labels) {
    const sheets = componentsBySheet(ldcs);
    const componentOn = (sheet, label) => {
        const option_1 = tryFind(sheet, sheets);
        if (option_1 != null) {
            return tryFind_1((comp) => (comp.Label === label), option_1);
        }
        else {
            return undefined;
        }
    };
    const walk = (sheet_1_mut, ids_mut, labels_1_mut) => {
        walk:
        while (true) {
            const sheet_1 = sheet_1_mut, ids = ids_mut, labels_1 = labels_1_mut;
            if (!isEmpty(labels_1)) {
                if (isEmpty(tail(labels_1))) {
                    const option_3 = componentOn(sheet_1, head(labels_1));
                    if (option_3 != null) {
                        return [option_3.Id, ids];
                    }
                    else {
                        return undefined;
                    }
                }
                else {
                    const option_7 = componentOn(sheet_1, head(labels_1));
                    if (option_7 != null) {
                        const comp_2 = option_7;
                        const option_5 = sheetInstantiatedBy(comp_2);
                        if (option_5 != null) {
                            sheet_1_mut = option_5;
                            ids_mut = cons(comp_2.Id, ids);
                            labels_1_mut = tail(labels_1);
                            continue walk;
                        }
                        else {
                            return undefined;
                        }
                    }
                    else {
                        return undefined;
                    }
                }
            }
            else {
                return undefined;
            }
            break;
        }
    };
    return walk(topSheet, empty(), labels);
}

/**
 * The saved form of one selected wave.
 */
export function pathOfSignal(ldcs, topSheet, wi) {
    let option_1;
    const tupledArg = wi.Id;
    option_1 = pathOfComponent(ldcs, topSheet, tupledArg[0], tupledArg[1]);
    if (option_1 != null) {
        return new WavePath(option_1, wi.PortType, wi.PortNumber);
    }
    else {
        return undefined;
    }
}

/**
 * The wave a saved path names.
 * 
 * `SimArrayIndex` is left at -1: it is a fact about a build, and there is no build here. The wave
 * simulator fills it in when one exists (`WaveSimHelpers.reResolveWave`), which it has to do after
 * every rebuild in any case.
 */
export function signalOfPath(ldcs, topSheet, path) {
    const option_1 = componentOfPath(ldcs, topSheet, path.WPLabels);
    if (option_1 != null) {
        return new WaveIndexT(-1, option_1, path.WPPortType, path.WPPortNumber);
    }
    else {
        return undefined;
    }
}

